import React from 'react'
import ListingPage, { TABLE_ACTIONS } from '../../../containers/ListingPage'
import { Row, Cell } from '../../../components/Table'
import { DropDown, DropDownItem, ICONS } from '../../../components/DropDown'

import EndpointForm from './Form'
import EndpointsFilter from './Filters'

import { getMessage } from '../../../lib/translator'

import EmptyIcon from '../UserShifts/employeeEmpty.svg'
import './style.css'

// Read: backend returns allowedMethods as a map {GET:true,...} and the enterprise/override
// flags as 0/1. The list/detail table + form want an array of methods and booleans.
export const toDisplay = (e) => ({
  ...e,
  allowedMethods: Array.isArray(e.allowedMethods)
    ? e.allowedMethods
    : Object.keys(e.allowedMethods || {}).filter((m) => e.allowedMethods[m]),
  allowEnterpriseAccess: !!Number(e.allowEnterpriseAccess),
  allowAuthorizationOverride: !!Number(e.allowAuthorizationOverride),
})

// list → array of endpoints, create/update → a single endpoint object. Shape-agnostic.
export const transformEndpointsResponse = (response) => {
  const data = response.data.endpoint
  return Array.isArray(data) ? data.map(toDisplay) : toDisplay(data)
}

export const transformEndpointSubmit = (formData) => ({
  url: formData.url,
  allowedMethods: Array.isArray(formData.allowedMethods)
    ? formData.allowedMethods
    : [],
  allowEnterpriseAccess: formData.allowEnterpriseAccess ? 1 : 0,
  allowAuthorizationOverride: formData.allowAuthorizationOverride ? 1 : 0,
})

export const EmptyState = {
  icon: EmptyIcon,
  message: getMessage('endpoint.empty.message'),
  actions: ({ onAction }) => (
    <button
      className="primary button"
      onClick={() => {
        onAction(TABLE_ACTIONS.ADD)
      }}
    >
      {`+ ${getMessage('endpoint.add')}`}
    </button>
  ),
}

export const TableProperties = {
  headers: [
    getMessage('endpoint.url'),
    getMessage('endpoint.methods'),
    getMessage('endpoint.action'),
  ],
  row: ({ id, url, allowedMethods, onAction }) => (
    <Row>
      <Cell>
        <span
          className="endpoint-url"
          onClick={() => onAction(TABLE_ACTIONS.EDIT, { id })}
        >
          {url}
        </span>
      </Cell>
      <Cell>{(allowedMethods || []).join(', ')}</Cell>
      <Cell>
        <DropDown icon={<img src={ICONS.VELLIP} alt="⋮" />}>
          <DropDownItem onClick={() => onAction(TABLE_ACTIONS.EDIT, { id })}>
            {getMessage('endpoint.edit')}
          </DropDownItem>
          <DropDownItem onClick={() => onAction(TABLE_ACTIONS.DELETE, { id })}>
            {getMessage('endpoint.delete')}
          </DropDownItem>
        </DropDown>
      </Cell>
    </Row>
  ),
}

// Rendered inside the Roles/Endpoints tab wrapper WITHOUT a `menu` prop, so ListingPage uses
// the bare WithoutMenuPage wrapper (no second sidebar).
export default class EndpointsTab extends React.Component {
  render() {
    return (
      <ListingPage
        className="endpoints-page"
        modalClassName="endpoint-edit-popup"
        addHeading={getMessage('endpoint.add.heading')}
        editHeading={getMessage('endpoint.edit.heading')}
        api={{
          url: '/account-service/endpoint',
          transform: transformEndpointsResponse,
        }}
        tableProperties={TableProperties}
        emptyState={EmptyState}
        headerActions={({ onAction }) => (
          <button
            className="primary button"
            onClick={() => {
              onAction(TABLE_ACTIONS.ADD)
            }}
          >{`+ ${getMessage('endpoint.add')}`}</button>
        )}
        form={{
          component: EndpointForm,
          transformSubmit: transformEndpointSubmit,
        }}
        filters={{ component: EndpointsFilter }}
      />
    )
  }
}
